import React, { Fragment } from 'react'
import TutorialCard from './TutorialCard'
import { Row, Col } from 'react-bootstrap'

export default function StaffTutorials({ handleShowTutorial }) {

  return (
    <Fragment>
      <Row className='mb-3'>
        <Col>
          <TutorialCard 
            icon={<i className="far fa-file-alt fa-sm text-light"></i>}
            title='Forms'
            tutorials={[
              { id: 1, link: 'https://www.youtube.com/embed/cnqBOrnMhgg', title: 'How to send a form' },
            ]}
            showTutorial={handleShowTutorial}
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <TutorialCard 
            icon={<i className="fas fa-laptop-medical fa-sm text-light"></i>}
            title='Telehealth'
            tutorials={[
              { id: 2, link: 'https://www.youtube.com/embed/giIi28vS2O0', title: 'How to schedule a telehealth appointment' },
            ]}
            showTutorial={handleShowTutorial}
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <TutorialCard 
            icon={<i className="far fa-calendar-alt fa-sm text-light"></i>}
            title='Events'
            tutorials={[
              { id: 3, link: 'https://www.youtube.com/embed/_U-1QhkRwEk', title: 'How to schedule an event' },
            ]}
            showTutorial={handleShowTutorial}
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <TutorialCard 
            icon={<i className="far fa-comment-dots fa-sm text-light" aria-hidden="true"></i>}
            title='Messages'
            tutorials={[
              { id: 4, link: 'https://www.youtube.com/embed/wE3CVpj9sIk', title: 'How to send a patient messsage' },
            ]}
            showTutorial={handleShowTutorial}
          />
        </Col>
      </Row>

      {/* NEED VIDEO */}
      {/* <Row className='mb-3'>
        <Col>
          <TutorialCard 
            icon={<i className="fa fa-filter fa-sm text-light" aria-hidden="true"></i>}
            title='Intake'
            tutorials={[
              { id: 5, title: 'How to use a form through Intake (Need Vid)' }
            ]}
            showTutorial={handleShowTutorial}
          />
        </Col>
      </Row> */}
    </Fragment>
  )
}